// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { ParagraphComponent } from '@openbank/ziniaweb-ui-components';
import { SuccessDescriptionPendingComponent } from './components/pending/success-description-pending.component';
import { SuccessDescriptionThankYouComponent } from './components/thank-you/success-description-thank-you.component';
// Constants
import { SUCCESS_PARAGRAPH_BOLD_PROPS } from './constants/success-description.constants';
// Hooks
import { useAppContextConsumerHook } from 'contexts/app.context';
// Styles
import { SuccessDescriptionStyled } from '../../success.container.styled';
// Translations
import { DEFAULTS, SUBTITLES } from '../../translations/success.translations';
// Utils
import { isPendingPage } from 'entrypoint/components/orchestrator/utils/entrypoint-orchestrator.utils';

const SuccessDescriptionComponent = (): React.JSX.Element => {
  const { currentState } = useAppContextConsumerHook();
  return (
    <SuccessDescriptionStyled>
      <ParagraphComponent {...SUCCESS_PARAGRAPH_BOLD_PROPS}>
        <FormattedMessage id={SUBTITLES[currentState] || DEFAULTS.SUBTITLE} />
      </ParagraphComponent>
      {isPendingPage(currentState) ? (
        <SuccessDescriptionPendingComponent />
      ) : (
        <SuccessDescriptionThankYouComponent />
      )}
    </SuccessDescriptionStyled>
  );
};

export { SuccessDescriptionComponent };
